// @flow
import _ from 'lodash';
import type { TRootStore } from "../../types";

export const getTransactionsHistoryById = (state: TRootStore) => _.groupBy(
	_.get(state, 'leagues.transaction_history.result', []), 'external_id'
);

export default getTransactionsHistoryById;


// WEBPACK FOOTER //
// ./src/modules/selectors/league/getTransactionsHistoryById.js